import { createFileRoute } from '@tanstack/react-router'
import { CommunicationsContactsPage } from '@/pages/communications/communications-contacts-page'

export const Route = createFileRoute('/communications/settings')({
  component: CommunicationsContactsPage,
})
